export default __webpack_public_path__ + "static/media/texting-skater-mycguld.49b17f90.jpg";